// Generated by CoffeeScript 1.12.7

/*
Like angular orderBy filter, but allows reversing each parameter individually (even getters)
 */

(function() {
  angular.module('smart-table').filter('multiOrderBy', function() {
    return require('orderby');
  });

}).call(this);
